import {
  InvoiceListType,
  SourceStatusEnum,
  InvoiceOverviewType,
  InvoiceOverviewRateEnum,
} from '@am3nd-org/pointcraft-types';

export const mockInvoiceOverviews: {
  [key: string]: InvoiceOverviewType;
} = {
  outstanding: {
    numberOfInvoices: 5,
    amount: 1000,
    percentage: 20,
    rate: InvoiceOverviewRateEnum.INCREASE,
  },
  overdue: {
    numberOfInvoices: 3,
    amount: 500,
    percentage: 10,
    rate: InvoiceOverviewRateEnum.DECREASE,
  },
  unpaid: {
    numberOfInvoices: 3,
    amount: 500,
    percentage: 10,
    rate: InvoiceOverviewRateEnum.DECREASE,
  },
  partial: {
    numberOfInvoices: 3,
    amount: 500,
    percentage: 10,
    rate: InvoiceOverviewRateEnum.DECREASE,
  },
  paid: {
    numberOfInvoices: 3,
    amount: 500,
    percentage: 10,
    rate: InvoiceOverviewRateEnum.DECREASE,
  },
};

export const mockInvoiceList: InvoiceListType[] = [
  {
    id: '4UK8WN9XU36',
    date: new Date('2022-07-25T19:08:50Z'),
    dueDate: new Date('2023-07-01T04:34:26Z'),
    amount: 545,
    balanceDue: 690,
    status: SourceStatusEnum.OVERDUE,
    customerName: 'Oralia Arniz',
  },
  {
    id: '6QT3ND8GK94',
    date: new Date('2022-02-07T10:28:05Z'),
    dueDate: new Date('2022-09-03T04:29:40Z'),
    amount: 236,
    balanceDue: 591,
    status: SourceStatusEnum.OVERDUE,
    customerName: 'Linet Vanne',
  },
  //   {
  //     id: '7V97EK1RU54',
  //     date: '2022-02-06T03:24:20Z',
  //     dueDate: '2023-03-05T08:06:08Z',
  //     amount: 124,
  //     balanceDue: 69,
  //     status: 'overdue',
  //     customerName: 'Loria Pirolini',
  //   },
  //   {
  //     id: '2J63MF4EH70',
  //     date: '2022-04-25T05:06:57Z',
  //     dueDate: '2024-02-28T15:48:16Z',
  //     amount: 143,
  //     balanceDue: 837,
  //     status: 'partial',
  //     customerName: "Celesta O'Hanley",
  //   },
  //   {
  //     id: '7RV9EQ4RF11',
  //     date: '2023-11-22T17:14:57Z',
  //     dueDate: '2023-09-03T10:54:36Z',
  //     amount: 955,
  //     balanceDue: 517,
  //     status: 'paid',
  //     customerName: 'Brinna Heymann',
  //   },
  //   {
  //     id: '1V74Q98WK10',
  //     date: '2022-12-04T08:38:55Z',
  //     dueDate: '2022-11-26T07:22:47Z',
  //     amount: 320,
  //     balanceDue: 329,
  //     status: 'partial',
  //     customerName: 'Margalit Brotherhead',
  //   },
  //   {
  //     id: '2YD4G38FJ14',
  //     date: '2022-03-30T23:19:10Z',
  //     dueDate: '2023-12-25T19:05:18Z',
  //     amount: 23,
  //     balanceDue: 523,
  //     status: 'paid',
  //     customerName: 'Francisca Sinncock',
  //   },
  //   {
  //     id: '9CR8UY4QG57',
  //     date: '2022-01-13T06:41:58Z',
  //     dueDate: '2023-06-19T22:31:46Z',
  //     amount: 195,
  //     balanceDue: 933,
  //     status: 'paid',
  //     customerName: 'Britte Allatt',
  //   },
];
